<div class="overlay">
    <div class="detail-overlay" style="overflow: hidden">
        <div class="detail-view">

            <section class="detail-head" [style.background]="headerColor">
                <header class="detail-header">
                    <h1 class="detail-heading">{{ 'screens.dashboard.comparison.tileHeading' | translate }}</h1>
                    <button class="iona-icon-only-button info white"
                            angulartics2On="click" angularticsCategory="Detailansichten"
                            angularticsAction="detail_info_text" angularticsLabel="Vergleich"
                            (click)="infoVisible = !infoVisible">
                    </button>
                    <button class="iona-icon-only-button close white" (click)="close()"></button>
                </header>
            </section>

            <section class="detail-info" *ngIf="infoVisible">
                <div class="icon">
                    <i class="info-icon"></i>
                </div>
                <div class="info-text">
                    <h2 class="font-bold">{{ 'screens.dashboard.comparison.subheading' | translate }}</h2>
                    <p>
                        {{ 'screens.dashboard.comparison.detailInfoTextIona' | translate }}
                    </p>
                </div>
            </section>

            <section class="tariff-warning" *ngIf="isErnaUser && userTariffService.tariffsAvailable()">
                <div class="heading" (click)="toggleWarning()">
                    <div class="collapse">
                        <div class="title">{{ 'screens.dashboard.comparison.ernaTariff' | translate }}</div>
                        <i [class]="warningCollapsed ? 'collapsed' : 'expand'"></i>
                    </div>
                </div>
                <ng-container *ngIf="!warningCollapsed">
                    <div class="content-wrapper">
                        <div class="content">
                            <div>
                                <p>{{ 'screens.dashboard.comparison.ionaWarning' | translate }}</p>
                                <button class="iona-icon-button-after internal-link white" (click)="routeToProfile()">
                                    {{'common.myData' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </section>

            <div class="tab-bar comparison">
                <div [class.active]="currentMode === comparisonMode.STATIC"
                     (click)="setMode(comparisonMode.STATIC)">
                    {{ 'screens.dashboard.comparison.static' | translate }}
                </div>
                <div [class.active]="currentMode === comparisonMode.DYNAMIC"
                     (click)="setMode(comparisonMode.DYNAMIC)">
                    {{ 'screens.dashboard.comparison.customizable' | translate }}
                </div>
                <div class="proxy-tab"></div>
            </div>

            <section class="detail-content">
                <div class="upper-timeframe-select">
                    <div *ngFor="let s of seriesLegend" class="center-contents legend-item">
                        <span class="color-dot" [style.background]="s.color"></span> {{s.name}}
                    </div>

                    <!-- DISPLAY MODE SELECTOR -->
                    <select class="iona-select small"
                            (change)="setDisplayMode($event.target.value)">
                        <option value="consumption"
                                [selected]="currentDisplayMode === comparisonDisplayMode.CONSUMPTION">
                            {{ 'screens.dashboard.comparison.consumption' | translate }}
                        </option>
                        <ng-container *ngIf="!isVisionUser">
                            <option value="cost" [selected]="currentDisplayMode === comparisonDisplayMode.COST">
                                {{ 'screens.dashboard.comparison.cost' | translate }}
                            </option>
                        </ng-container>
                        <ng-container
                            *ngIf="!application.isDemoMode() && currentDataMode !== comparisonDataMode.HAPPY_HOUR">
                            <option [value]="comparisonDisplayMode.FEEDIN"
                                    [selected]="currentDisplayMode === comparisonDisplayMode.FEEDIN">
                                {{ 'screens.dashboard.comparison.feedIn' | translate }}
                            </option>
                        </ng-container>
                    </select>

                    <div class="p-h-s"></div>

                    <!-- COMPARISON MODE SELECTOR -->
                    <select class="iona-select small" (change)="setTimeframe($event.target.value)"
                            angulartics2On="change"
                            angularticsCategory="Detailansichten"
                            angularticsAction="detail_time_interval_change"
                            angularticsLabel="{{ 'screens.dashboard.comparison.tileHeading' | translate }} - {{ currentMode === comparisonMode.STATIC ? ('screens.dashboard.comparison.static' | translate) : ('screens.dashboard.comparison.cutomizable' | translate) }}">
                        <option [value]="comparisonTimeframe.DAY">{{ 'screens.dashboard.comparison.day' | translate }}</option>
                        <option [value]="comparisonTimeframe.WEEK">{{ 'screens.dashboard.comparison.week' | translate }}</option>
                        <option [value]="comparisonTimeframe.MONTH" selected>{{ 'screens.dashboard.comparison.month' | translate }}</option>
                        <option [value]="comparisonTimeframe.YEAR">{{ 'screens.dashboard.comparison.year' | translate }}</option>
                    </select>

                    <!-- HAPPY HOUR SWITCH -->
                    <ng-container *ngIf="userHasHappyHour && currentDisplayMode !== comparisonDisplayMode.FEEDIN && !isVisionUser">
                        <div class="happy-hour-switch">
                            <div class="center-contents"
                                 [ngClass]="{'active' : currentDataMode === comparisonDataMode.REGULAR}"
                                 (click)="setDataMode(comparisonDataMode.REGULAR)">
                                {{'screens.dashboard.householdComparison.detailLabels.tabTotal' | translate}}
                            </div>
                            <div class="center-contents"
                                 [ngClass]="{'active' : currentDataMode !== comparisonDataMode.REGULAR}"
                                 (click)="setDataMode(comparisonDataMode.HAPPY_HOUR)">
                                {{'screens.dashboard.householdComparison.detailLabels.happyHour' | translate}}
                            </div>
                        </div>
                    </ng-container>
                </div>

                <app-comparison-chart (chartLoaded)="onChartLoaded($event)"
                                      (seriesAdded)="updateLegend($event)">
                </app-comparison-chart>

                <div class="diagram-controls" [ngSwitch]="currentMode">
                    <div *ngSwitchCase="comparisonMode.STATIC" class="comparison-static-diagram-controls">
                        <div>
                            <button class="iona-icon-only-button prev"
                                    [disabled]="interactionDisabled|| positionBackDisabled()"
                                    (click)="positionBack()">
                            </button>
                        </div>
                        <div class="base-price-display">
                            <div *ngIf="currentDisplayMode === comparisonDisplayMode.COST">
                                {{ 'screens.dashboard.comparison.basePriceLabel' | translate }}
                                <strong>
                                    {{this.currentBasePrice | async}}
                                </strong>
                            </div>
                        </div>
                        <div class="right-controls">
                            <button class="iona-icon-only-button next"
                                    [disabled]="interactionDisabled || positionForwardDisabled()"
                                    (click)="positionForward()">
                            </button>
                            <div class="m-h-s"></div>
                            <div class="button-constraint-container">
                                <button class="iona-button small outline"
                                        [disabled]="interactionDisabled || positionForwardDisabled()"
                                        (click)="positionNow()">
                                    {{ 'common.now' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="comparisonMode.DYNAMIC">
                        <div class="comparison-dynamic-diagram-controls">
                            <div>
                                <select *ngIf="currentTimeframe === comparisonTimeframe.DAY"
                                        class="iona-select small" id="left_day"
                                        (change)="setComparisonDates('lhsDay', $event.target.value)">
                                    <option *ngFor="let date of loop(1, 31)" value="{{ date }}"
                                            [selected]="dynamicComparisonDates.lhsDay === date">{{ date }}</option>
                                </select>
                                <select *ngIf="currentTimeframe === comparisonTimeframe.WEEK"
                                        class="iona-select small" id="left_kw"
                                        (change)="setComparisonDates('lhsCalendarWeek', $event.target.value)">
                                    <option *ngFor="let calendarWeek of loop(1, 52)" value="{{ calendarWeek }}"
                                            [selected]="dynamicComparisonDates.lhsCalendarWeek === calendarWeek">
                                        KW {{ calendarWeek }}</option>
                                </select>
                                <select
                                    *ngIf="(currentTimeframe === comparisonTimeframe.DAY) || (currentTimeframe === comparisonTimeframe.MONTH)"
                                    class="iona-select small" id="left_month"
                                    (change)="setComparisonDates('lhsMonth', $event.target.value)">
                                    <option *ngFor="let month of validMonths; let i = index" value="{{ i + 1 }}"
                                            [selected]="dynamicComparisonDates.lhsMonth === (i + 1)">{{ month }}</option>
                                </select>
                                <select class="iona-select small" id="left_year"
                                        (change)="setComparisonDates('lhsYear', $event.target.value)">
                                    <option *ngFor="let year of loop(year - 4, 5)" value="{{ year }}"
                                            [selected]="dynamicComparisonDates.lhsYear === year">{{ year }}</option>
                                </select>
                            </div>
                            <div>
                                <select *ngIf="currentTimeframe === comparisonTimeframe.DAY"
                                        class="iona-select small" id="right_day"
                                        (change)="setComparisonDates('rhsDay', $event.target.value)">
                                    <option *ngFor="let date of loop(1, 31)" value="{{ date }}"
                                            [selected]="dynamicComparisonDates.rhsDay === date">{{ date }}</option>
                                </select>
                                <select *ngIf="currentTimeframe === comparisonTimeframe.WEEK"
                                        class="iona-select small" id="right_kw"
                                        (change)="setComparisonDates('rhsCalendarWeek', $event.target.value)">
                                    <option *ngFor="let calendarWeek of loop(1, 52)" value="{{ calendarWeek }}"
                                            [selected]="dynamicComparisonDates.rhsCalendarWeek === calendarWeek">
                                        KW {{ calendarWeek }}</option>
                                </select>
                                <select
                                    *ngIf="(currentTimeframe === comparisonTimeframe.DAY) || (currentTimeframe === comparisonTimeframe.MONTH)"
                                    class="iona-select small" id="right_month"
                                    (change)="setComparisonDates('rhsMonth', $event.target.value)">
                                    <option *ngFor="let month of validMonths; let i = index" value="{{ i + 1 }}"
                                            [selected]="dynamicComparisonDates.rhsMonth === (i + 1)">{{ month }}</option>
                                </select>
                                <select class="iona-select small" id="right_year"
                                        (change)="setComparisonDates('rhsYear', $event.target.value)">
                                    <option *ngFor="let year of loop(year - 4, 5)" value="{{ year }}"
                                            [selected]="dynamicComparisonDates.rhsYear === year">{{ year }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="base-price-display"
                             [class.no-display]="currentDisplayMode !== comparisonDisplayMode.COST">
                            <div *ngIf="currentDisplayMode === comparisonDisplayMode.COST">
                                {{ 'screens.dashboard.comparison.basePriceLabel' | translate }}
                                <strong>{{currentBasePrice | async}}</strong>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </div>
    </div>
</div>

